window.gsWeb = window.gsWeb || {};

(function ($) {
    var signatureJbp = function(){
        var cls = this;

        // video js 옵션 셋팅
        var vjsSetting2 = {
            preload: 'auto',
            autoplay: false,
            muted: true,
            playsinline: true,
            //	화면 비율 설정을 안할경우 Parent 또는 css 설정 기준 사이즈
            //	fluid: true, // 동영상 사이즈에 맞춰서 자동으로 크기조정
            //	aspectRatio: '16:9', // 화면비율 설정
            controlBar: {
                children: [
                    'playToggle',
                    'volumePanel',
                ]
            },
            multicheck: true, // 스와프 멀티 체크!!
            grouping: true, // 커스텀 설정 - 컨트롤러 그룹핑
        };

        var vjsHowToSet = {
            autoplay: false,
            muted: true,
            playsinline: true,
            fluid: true, // 동영상 사이즈에 맞춰서 자동으로 크기조정
            aspectRatio: '12:5', // 화면비율 설정
            controlBar: {
                children: [
                    'playToggle',
                    'volumePanel',
                    'fullscreenToggle',
                    'remainingTimeDisplay',
                    'currentTimeDisplay',
                    'durationDisplay',
                    'progressControl'
                ]
            },
            limitTime: 60, //  커스텀 설정 - 제한시간 ( 초단위 : 임시 5초 )
            useLimit: true, // 커스텀 설정 - 제한시간 활성 체크
            grouping: true, // 커스텀 설정 - 컨트롤러 그룹핑( 기존 플레이어 영향도 회피 )
        }


        var lseq = {
            'ZZIM' : '448600',
            'VOD' : '448610',
            'BRAND_STORY' : '448611'
        }

        cls.init = function(){
            cls.setEvent();
        };

        cls.setEvent = function(){
            // 찜
            $('a[name="lseqZzim"]').off('click').on('click', function() {
                LSeqUtil.clickLseqSend(lseq['ZZIM']);
            });

            // 브랜드스토리 더보기
            $('#brandStoryMore').off('click').on('click', function() {
                LSeqUtil.clickLseqSend(lseq['BRAND_STORY']);
            });

            var gsHowToMov = document.querySelectorAll('.gsHowToMov');
            if (gsHowToMov) {
                gsHowToMov.forEach(function (value) {
                    var vjs_player = videojs( value, vjsHowToSet, gs.vod.init );

                    vjs_player.on('play', function(){
                        LSeqUtil.clickLseqSend(lseq['VOD']);
                    });
                });
            }

            var gsPlayers = [];
            var swipePlayer = document.querySelectorAll('.vod-slider .gui-video');

            swipePlayer.forEach(function( mov ) {
                var vjs_player = videojs( mov, vjsSetting2,  gs.vod.init );

                gsPlayers.push( vjs_player ); // 배열 담기
            });

            $('[data-swipe="best-review"]').gsSwiper({
                autoplay:0,
                speed:500,
                loop: true,
                slidesPerView: 3,
                calculateHeight: true,
                slidesPerGroup	: 1,
                prevClass: 'new_prev',
                nextClass: 'new_next',
                onInit: function(t){
                    gs.vod.swiperChange( t );
                },
                onChangeStart: function(t){
                    gs.vod.swiperChange( t );
                }
            });
        }

        return cls;
    };

    window.signatureJbp = window.signatureJbp || new signatureJbp();
    window.signatureJbp.init();
})(jQuery);